import React, { useEffect, useState } from "react";

const ProductBlockSliderScrollbar = ({ carouselState }) => {

  const [width, setWidth] = useState(0);
  const [left, setLeft] = useState(0);

  useEffect(() => {
    if (!carouselState) return;

    const { totalItems, slidesToShow, currentSlide } = carouselState;

    const widthPercent = (slidesToShow / totalItems) * 100;
    const percentPerItem = 100 / totalItems;
    const leftPercent = percentPerItem * currentSlide;

    setWidth(widthPercent);
    setLeft(leftPercent);

  }, [carouselState]);

  return (
    <div className="product-carousel-scrollbar">
      <div
        className="product-carousel-scrollbar__thumb"
        style={{
          width: `${width}%`,
          left: `${left}%`
        }}
      />
      <div className="product-carousel-scrollbar__track" />
    </div>
  );
};

export default ProductBlockSliderScrollbar;